import React, { useRef } from "react";
import DownloadExcel from "../../Extra/DownloadExcel";
import {
  secondsToHHMM,
  secondsToTime,
  sumArrayOfObjects,
} from "../../Utilitie";

const MonthWiseHQRest = ({ data }) => {
  //  console.log(data);
  const lobbyWiseSum = sumArrayOfObjects(
    data,
    ["hq_lobby", "hq_crew_lobby", "hq_month"],
    [],
    "group_id",
  );
  lobbyWiseSum.sort((a, b) => {
    if (a.hq_year !== b.hq_year) return a.hq_year - b.hq_year;
    if (a.hq_month !== b.hq_month) return a.hq_month - b.hq_month;
    return b.hq_occurence - a.hq_occurence;
  });

  const countKeys = (array) => {
    return array.reduce((acc, curr) => {
      const key = `${curr.hq_lobby}|${curr.hq_crew_lobby}|${curr.hq_month}`;

      acc[key] = (acc[key] || 0) + 1;

      return acc;
    }, {});
  };

  const groupKeyCount = countKeys(data);
  // console.log(groupKeyCount);
  const tableRef = useRef();
  const monthTotals = lobbyWiseSum.reduce((acc, row) => {
    const key = `${row.hq_year}-${row.hq_month}`;
    if (!acc[key]) {
      acc[key] = {
        hq_occurence: 0,
        hq_total_rest: 0,
        hq_month: row.hq_month,
      };
    }
    acc[key].hq_occurence += row.hq_occurence;
    acc[key].hq_total_rest += row.hq_total_rest;
    return acc;
  }, {});
  lobbyWiseSum.sort((a, b) => {
    if (a.hq_lobby !== b.hq_lobby) return a.hq_lobby.localeCompare(b.hq_lobby);

    if (a.hq_month !== b.hq_month) return a.hq_month.localeCompare(b.hq_month);

    return b.hq_occurence - a.hq_occurence;
  });

  return (
    <div className="newUiBody">
      <div
        className="table-responsive  p-0 m-0"
        style={{ maxHeight: "500px", overflow: "auto" }}
      >
        <table
          className="table newUiTable table-striped table-hover  "
          ref={tableRef}
        >
          <thead className="sticky-top " style={{ zIndex: 2 }}>
            <tr className="table-dark  ">
              <th>SNo</th>
              <th>Lobby</th>
              <th>Month</th>
              <th>Crew Lobby</th>
              <td>Average Rest</td>
              <th>Occurence</th>
              <th>Total Rest</th>
            </tr>
          </thead>
          <tbody>
            {lobbyWiseSum.map((obj, ind) => {
              return (
                <tr key={ind}>
                  {/* {console.log(obj, groupKeyCount[obj.group_id])} */}
                  <td>{ind + 1}</td>
                  <td>{obj.hq_lobby}</td>
                  <td>{obj.hq_month}</td>
                  <td>{obj.hq_crew_lobby}</td>
                  {/* <td>{secondsToHHMM(obj.hq_os_crew_avg_rest_at_hq)}</td> */}
                  <td>
                    {secondsToTime(
                      obj.hq_os_crew_avg_rest_at_hq /
                        groupKeyCount[obj.group_id],
                    )}
                  </td>
                  <td>{obj.hq_occurence}</td>
                  <td>{secondsToHHMM(obj.hq_total_rest)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <DownloadExcel tableRef={tableRef} fileName={`crew utilization`} />
    </div>
  );
};
export default MonthWiseHQRest;
